/**
 * Límites de entrada y formatos de audio del chat con Papá Noel. Puro y sin
 * dependencias: lo comparten el servidor (ruta, servicio, transcripción) y la
 * pantalla del chat (compositor, subida de la nota), así que hay un solo sitio
 * donde cambiarlos.
 */
export const SANTA_CHAT_INPUT_LIMITS = {
  /** Texto escrito, tras normalizar los saltos de línea. */
  maxTextLength: 300,
  /** Lo corta el grabador del navegador (Ruling R1: el servidor no mide la duración). */
  maxAudioSeconds: 30,
  maxAudioBytes: 1_048_576,
} as const

/** Tipos de audio que acepta el chat y la extensión con la que viaja cada uno. */
export const SANTA_CHAT_AUDIO_TYPES = {
  'audio/webm': 'webm',
  'audio/mp4': 'm4a',
} as const

export type SantaChatAudioExtension = (typeof SANTA_CHAT_AUDIO_TYPES)[keyof typeof SANTA_CHAT_AUDIO_TYPES]

/** `audio/webm;codecs=opus` -> `audio/webm`. */
export function baseAudioMimeType(type: string): string {
  return (type.split(';')[0] ?? '').trim().toLowerCase()
}

/** Extensión de un tipo de audio admitido (con o sin `;codecs=`); `null` si no se admite. */
export function santaChatAudioExtension(type: string): SantaChatAudioExtension | null {
  const base = baseAudioMimeType(type)
  return Object.hasOwn(SANTA_CHAT_AUDIO_TYPES, base)
    ? SANTA_CHAT_AUDIO_TYPES[base as keyof typeof SANTA_CHAT_AUDIO_TYPES]
    : null
}
